import {
 InputRef,
 Menu,
 Input,
 Spin,
 Checkbox,
 Empty,
 Tooltip,
 Button,
 Space,
 Badge,
} from 'antd'
import { MTFilterOption } from 'components/shared/MDataTable/type'
import React, { FC, useEffect, useRef, useState } from 'react'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { useDebounce } from 'react-use'
import { areArraysEqual } from 'utils/functions'

const CustomSourceFilter: FC<{
 filterLoading: boolean
 options?: MTFilterOption[]
 onHide?: () => void
 value?: any[]
 onClickSubmit: (val: any[], isPrevious: boolean) => void
 IsPreviousValue: boolean
}> = ({
 filterLoading,
 options,
 onHide,
 value,
 onClickSubmit,
 IsPreviousValue,
}) => {
 const [searchKey, setSearchKey] = useState('')
 const [data, setData] = useState(options || [])
 const [checkedList, setCheckedList] = useState<any[]>([])
 const [indeterminate, setIndeterminate] = useState(false)
 const [checkAll, setCheckAll] = useState(false)
 const [isPrevious, setIsPrevious] = useState(IsPreviousValue)
 const filterRef = useRef<InputRef>(null)

 useEffect(() => {
  if (filterRef?.current) {
   filterRef.current.focus()
  }
 }, [])

 useEffect(() => {
  setCheckedList(value ?? [])
 }, [value])

 const onCheckAllChange = (e: CheckboxChangeEvent): void => {
  setCheckedList(e.target.checked ? data?.map((v) => v.value) || [] : [])
  setCheckAll(e.target.checked)
 }

 const onChange = (info: any): void => {
  setCheckedList((prv) => {
   if (prv.find((m) => m === info.key)) {
    const newVal = prv.filter((m) => m !== info.key)
    return [...newVal]
   }
   return [...prv, info.key]
  })
 }

 useDebounce(
  () => {
   if (searchKey && options && options.length > 0) {
    setData(
     options?.filter((v) =>
      `${v.label}`
       .toLocaleLowerCase()
       .includes(searchKey.toLocaleLowerCase(), 0),
     ) || [],
    )
    setCheckAll(
     checkedList.length > 0
      ? data.every((xx) => checkedList.includes(xx.value))
      : false,
    )
    setIndeterminate(!!checkedList.length && checkedList.length < data.length)
   } else {
    setData(options || [])
    setCheckAll(
     areArraysEqual(
      data.map((v) => v.value),
      checkedList,
     ),
    )
    setIndeterminate(!!checkedList.length && checkedList.length < data.length)
   }
  },
  100,
  [options, searchKey, data, checkedList],
 )

 //  useEffect(() => {
 //   if (options) {
 //    setData(options)
 //   }
 //   // return () => {
 //   //  setSearchKey('')
 //   //  setCheckedList([])
 //   //  setCheckAll(false)
 //   //  setIndeterminate(false)
 //   //  setIsPrevious(false)
 //   // }
 //  }, [options])

 return (
  <div className="mt-filter-block">
   <div className="mt-filter-block-header">
    <div className="mt-filter-block-search">
     <Input.Search
      value={searchKey}
      onChange={({ target }) => {
       setSearchKey(target.value || '')
      }}
      placeholder="Search Sources"
      size="small"
      ref={filterRef}
     />
    </div>
    <div className="mt-filter-block-selectAll">
     <Checkbox
      disabled={data.length === 0}
      indeterminate={indeterminate}
      onChange={onCheckAllChange}
      checked={checkAll}
     >
      Select All
     </Checkbox>
     <Badge size="small" count={checkedList.length || 0} />
    </div>
   </div>
   <div className="mt-filter-block-header">
    <div className="mt-filter-block-selectAll">
     <Checkbox
      disabled={data.length === 0}
      onChange={() => setIsPrevious(!isPrevious)}
      checked={isPrevious}
     >
      Include Previous sources
     </Checkbox>
    </div>
   </div>
   <div className="mt-filter-block-body">
    <FiltersBody
     loading={filterLoading}
     checkedList={checkedList}
     data={data}
     onChange={onChange}
    />
   </div>
   <div className="mt-filter-block-footer">
    <Space>
     <Button size="small" onClick={onHide}>
      Cancel
     </Button>
     <Button
      size="small"
      onClick={() => {
       onClickSubmit(checkedList, isPrevious)
       onHide?.()
      }}
      type="primary"
      disabled={!checkedList.length}
     >
      Submit
     </Button>
    </Space>
   </div>
  </div>
 )
}

export default CustomSourceFilter

const FiltersBody: FC<{
 loading: boolean
 data: MTFilterOption[]
 onChange: (info: any) => void
 checkedList: any[]
}> = ({ loading, data, onChange, checkedList }) => {
 if (loading) {
  return (
   <div style={{ height: '130px' }}>
    <Spin
     size="small"
     className="w-100 h-100 d-flex justify-content-center align-items-center"
    />
   </div>
  )
 }
 if (!loading && (data?.length ?? 0) > 0) {
  return (
   <Menu
    multiple
    onClick={onChange}
    selectable={false}
    selectedKeys={checkedList}
   >
    {data?.map((item) => (
     <Menu.Item
      key={item.value}
      icon={
       <Checkbox checked={checkedList.find((v) => v === item.value)} type="" />
      }
     >
      <Tooltip title={item.label}>{item.label}</Tooltip>
     </Menu.Item>
    ))}
   </Menu>
  )
 }
 return <Empty description="Data Not Found!" />
}
